import React from "react";
import AppRoutes from "./routes/AppRoutes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const customTheme = createTheme({
  typography: {
    fontSize: 14,
    // body1: {
    //   fontSize: "0.875rem", // Equivalente a 14px
    // },
    body2: {
      fontSize: "0.75rem", // Equivalente a 12px
    },
    subtitle2: {
      fontSize: "0.675rem", // Equivalente a 14px
    },
  },
  palette: {
    primary: {
      main: "#2B7FFF",
    },
    secondary: {
      main: "#8a8c8dff",
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={customTheme}>
      <AppRoutes />
      <ToastContainer
        position="top-right"
        autoClose={3500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        toastStyle={{
          width: "auto", // largura automática
          maxWidth: "800px", // limite máximo
          whiteSpace: "normal", // permite quebrar linha se a mensagem for longa
        }}
      />
    </ThemeProvider>
  );
}

export default App;
